import { AspectRatio as MantineAspectRatio, AspectRatioProps } from '@mantine/core';
import { forwardRef } from 'react';

export type AspectRatioPreset = '16:9' | '4:3' | '1:1' | '21:9' | '9:16' | 'custom';

export interface ThemedAspectRatioProps extends Omit<AspectRatioProps, 'ratio'> {
  preset?: AspectRatioPreset;
  ratio?: number;
}

const presetRatios: Record<Exclude<AspectRatioPreset, 'custom'>, number> = {
  '16:9': 16 / 9,
  '4:3': 4 / 3,
  '1:1': 1,
  '21:9': 21 / 9,
  '9:16': 9 / 16,
};

const AspectRatio = forwardRef<HTMLDivElement, ThemedAspectRatioProps>(
  ({ preset = '16:9', ratio, children, ...rest }, ref) => {
    const computedRatio = ratio || presetRatios[preset as Exclude<AspectRatioPreset, 'custom'>] || 16 / 9;

    return (
      <MantineAspectRatio ref={ref} ratio={computedRatio} {...rest}>
        {children}
      </MantineAspectRatio>
    );
  }
);

AspectRatio.displayName = 'AspectRatio';

export default AspectRatio;
